export enum GlobalAsyncRules {
    ['show-external-link-button'] = 'show-external-link-button',
}